import {useSelector} from "react-redux";
import users from "../../users";
import {cn} from "../../../utils/utils";

import './link-v2.scss';
import {Link} from "react-router-dom";

type Props = {
    title?: string;
    children?: React.ReactNode;
    to: string;
    active?: boolean;
    disabled?: boolean;
    className?: string;
    size?: 'small' | 'medium' | 'large';
    variant?: 'danger' | 'primary' | 'secondary' | 'warning';
    width?: string | number;
    style?: React.CSSProperties;
    forceDarkMode?: 'light' | 'dark';
}

const LinkV2 = ({
                    title,
                    children,
                    to,
                    active,
                    forceDarkMode,
                    disabled,
                    className,
                    size,
                    variant,
                    width,
                    style
                }: Props) => {
    const darkMode = useSelector(users.selectors.isDarkMode);

    const isDarkMode = forceDarkMode ? (forceDarkMode === 'dark') : darkMode;


    return <Link to={to} target={to.startsWith('http') ? '_blank' : '_self'}
                 onClick={(e) => {
                     e.stopPropagation();
                 }}
                 className={cn("button-v2", {"button-v2--dark": isDarkMode}, {"button-v2--active": active}, className,
                     `button-v2--size-${size ?? 'medium'}`, `button-v2--type-${variant ?? 'primary'}`)}
                 style={{width: width, ...style}} title={title}>
        {children}
    </Link>;
}

export default LinkV2;
